<template>
    <div class="slot-machine">
        
        <p></p>
        <hr>
        <p></p>

        <b-card>
            <b-card-body>
                <div class="d-flex justify-content-center">
                    <img 
                        :src="image[image1.digits]" 
                        :style="getStyle(image1)" 
                        v-show="draw.maxNumber > 99"
                    />
                    <img 
                        :src="image[image2.digits]" 
                        :style="getStyle(image2)"
                        v-show="draw.maxNumber > 9"
                    />
                    <img 
                        :src="image[image3.digits]" 
                        :style="getStyle(image3)" 
                    />            
                </div>
            </b-card-body>
        </b-card>
        
        <p></p>
        <hr>
        <p></p>
        
        <div>
            <b-col cols="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
                <b-button block variant="danger" @click="drawNumbers()" style="font-size: 40px;">SORTEAR</b-button>
            </b-col>
        </div>

        <p></p>
        <hr>
        <p></p>
        
       
        
        <b-card no-body>
            <b-card-header @click="showHideConfig">
                <strong>Configuração</strong>
            </b-card-header>
            <b-card-body v-show="showConfig">
                <b-row>
                    <b-col sm="12">
                    <b-form-group>
                        <label for="maxnumber">Números</label>
                        <b-form-input v-model="draw.maxNumber" type="number" id="maxnumber" placeholder="Quantidade de números" @change="changeDrawNumber"></b-form-input>
                    </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12">
                    <b-form-group>
                        <label for="drawtime">Tempo (millisegundos)</label>
                        <b-form-input v-model="draw.time" type="number" id="drawtime" placeholder="Tempo em milisegundos"></b-form-input>
                    </b-form-group>
                    </b-col>
                </b-row>

                <div class="d-flex justify-content-center">
                    <button @click="scrollImage(image1)">{{ Math.round(image1.offsetY / size / 100, 0) }}</button>
                    <button @click="scrollImage(image2)">{{ Math.round(image2.offsetY / size / 100, 0) }}</button>
                    <button @click="scrollImage(image3)">{{ Math.round(image3.offsetY / size / 100, 0) }}</button>

                    <button @click="scrollImages">Girar Todos</button>            

                </div>
                
            </b-card-body>
        </b-card>

    </div>
  </template>
  
<script>

  import gsap from 'gsap'

  export default {
    data() {
      return {
        showConfig: false,
        draw: {
            time: 8,
            number: 0,
            minNumber: 1,
            maxNumber: 100
        },        
        size: 4,
        image: [
            "img/slotmachine.jpg",
            "img/slotmachine1.jpg",
            "img/slotmachine2.jpg",
            "img/slotmachine3.jpg",
            "img/slotmachine4.jpg",
            "img/slotmachine5.jpg",
            "img/slotmachine6.jpg",
            "img/slotmachine7.jpg",
            "img/slotmachine8.jpg",
            "img/slotmachine.jpg"
        ],
        image1: { digits: 2, offsetY: 0, scrollStep: 20, direction: 1 },
        image2: { digits: 9, offsetY: 0, scrollStep: 10, direction: -1 },
        image3: { digits: 9, offsetY: 0, scrollStep: 15, direction: -1 },
        imageHeight: 100   // Altura da imagem em pixels
      }
    },
    methods: {
        getStyle(image) {
            return {
                height: `${this.size * 100}px`,
                width: `${this.size * 100}px`,
                objectFit: "cover",
                margin: "0 10px",
                objectPosition: `0px ${-image.offsetY}px`, // Altera a posição vertical
            };
        },

        scrollImage(image) {
            image.offsetY = image.offsetY + (image.direction * this.size * image.scrollStep);
            if (image.offsetY >= (this.size * (image.digits + 1) * this.imageHeight)) {
                image.offsetY = 0;
            }
            if(image.direction==-1 && (this.size * image.offsetY) <= 0) {
                image.offsetY = this.size * (image.digits + 1) * this.imageHeight;
            }                
        },

        scrollImages() {
            [this.image1, this.image2, this.image3].forEach((image) => {
                image.offsetY = image.offsetY + (image.direction * this.size * image.scrollStep);

                if (image.offsetY >= (this.size * (image.digits + 1) * this.imageHeight)) {
                    image.offsetY = 0;
                }
                
                if(image.direction==-1 && (this.size * image.offsetY) <= 0) {
                    image.offsetY = this.size * (image.digits + 1) * this.imageHeight;
                }
            });
        },
        
        numberHundreds(value) {
            return Math.floor(value / 100) % 10
        },

        numberTens(value) {
            return Math.floor(value / 10) % 10
        },

        numberUnits(value) {
            return Math.floor(value) % 10
        },

        changeDrawNumber() {             
            if(this.draw.maxNumber > 99) {
                this.image1.digits =  this.numberHundreds(this.drawNumber)
                this.image2.digits = 9                
            }
            else {
                this.image2.digits = this.numberTens(this.draw.maxNumber)
            }            
            this.image2.offsetY = 0
            this.image1.offsetY = 0
            this.image3.offsetY = 0
        },

        drawNumbers() {
            this.draw.number = Math.floor(Math.random() * this.draw.maxNumber) + 1;
            console.log("Sorteado: " + this.draw.number + " [" +  this.numberHundreds(this.draw.number) + "] [" + this.numberTens(this.draw.number) + "] [" + this.numberUnits(this.draw.number) + "]")

            let counter = 0;
            let counter2 = 0;
            let redrawMult  = 0;
            const intervalId = setInterval(() => {
                counter++;
                
                if(counter >= ((this.draw.time * 100) - 500)) {
                    if(counter >= ((this.draw.time * 100) - 400)) {
                        if(counter >= ((this.draw.time * 100) - 300)) {
                            if(counter >= ((this.draw.time * 100) - 200)) {
                                if(counter >= ((this.draw.time * 100) - 100)) {
                                    if (counter >= (this.draw.time * 100)) {
                                        clearInterval(intervalId);
                                    }
                                    else {
                                        redrawMult = 5;
                                        counter2 = 0;
                                    }
                                }
                                else {
                                    redrawMult = 4;
                                    counter2 = 0;
                                }
                            }
                            else {
                                redrawMult = 3;
                                counter2 = 0;
                            }
                        }
                        else {
                            redrawMult = 2;
                            counter2 = 0;
                        }
                    }
                    else {
                        redrawMult = 1;
                        counter2 = 0;
                    }
                }
                
                if(counter2 >= (redrawMult * 10)) {
                    this.scrollImage(this.image1)
                    this.scrollImage(this.image2)
                    this.scrollImage(this.image3)
                    counter2 = 0;
                }                
                
            }, 10);
        },

        showHideConfig() {
            this.showConfig = !this.showConfig
        }


    }
  }
</script>
  
<style scoped>
</style>